/**
 * External dependencies
 */
import React from "react";
import { FormControl } from "react-bootstrap";
import { navigate } from "gatsby";
import { Debounce } from "react-throttle";

class SearchInput extends React.Component {
  handleOnChange = e => {
    const newRoute = `/search/?q=${e.target.value}`;
    navigate(newRoute);
  };

  render() {
    return (
      <Debounce time="800" handler="onChange">
        <FormControl
          type="text"
          placeholder="search for products"
          onChange={this.handleOnChange}
        />
      </Debounce>
    );
  }
}

export default SearchInput;
